import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=22af9dd2&scoped=true"
import script from "./WechatLogin.vue?vue&type=script&lang=js"
export * from "./WechatLogin.vue?vue&type=script&lang=js"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&id=22af9dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af9dd2",
  null
  
)

export default component.exports